import { render, staticRenderFns } from "./GrupoBet.vue?vue&type=template&id=543ff0ea&scoped=true"
import script from "./GrupoBet.vue?vue&type=script&lang=js"
export * from "./GrupoBet.vue?vue&type=script&lang=js"
import style0 from "./GrupoBet.vue?vue&type=style&index=0&id=543ff0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543ff0ea",
  null
  
)

export default component.exports